export default function camelCaseToTitle(camelCase) {
  return camelCase.replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
}
